const common = {
  site_name: 'Yoybuy Sheet',
  site_tagline: 'Сравнение агентов Китая',
  hero_title: 'Yoybuy Sheet — Ваш инструмент для сравнения Shopping-агентов Китая',
  hero_subtitle: 'Сравнивайте цены, скорость доставки и условия Yoybuy, Kakobuy и Superbuy в одной удобной таблице. Экономьте до 30% на каждом заказе из Китая.',
  btn_yoybuy_sheet: 'Yoybuy Sheet',
  btn_buy_now: 'Buy It Now',
  btn_open_spreadsheet: 'Открыть таблицу',
  btn_compare_agents: 'Сравнить агентов',
  btn_read_guide: 'Читать руководство',
  btn_all_categories: 'Все категории',
  category_title: 'Категории товаров',
  category_subtitle: 'Выберите категорию и перейдите к покупкам на Kaspreadsheet',
  category_shoes: 'Обувь',
  category_hoodies: 'Худи / Свитера',
  category_tshirts: 'Футболки',
  category_jackets: 'Куртки',
  category_pants: 'Штаны / Шорты',
  category_headwear: 'Головные уборы',
  category_sets: 'Комплекты',
  category_underwear: 'Нижнее бельё',
  category_jersey: 'Джерси',
  category_accessories: 'Аксессуары',
  category_bags: 'Сумки',
  category_belts: 'Ремни',
  category_perfumes: 'Парфюмерия',
  category_other: 'Разное',
  seo_section_title: 'Почему Yoybuy Sheet — лучший выбор для шоппинга из Китая',
  seo_section_text_1: 'Yoybuy Sheet представляет собой профессиональную систему электронных таблиц, разработанную специально для сравнения китайских shopping-агентов. С помощью нашего инструмента вы можете мгновенно сопоставить цены, сроки доставки, комиссии и отзывы по таким агентам, как Yoybuy, Kakobuy и Superbuy — всё в одном месте.',
  seo_section_text_2: 'В отличие от обычных обзоров и форумов, Yoybuy Sheet предлагает структурированный подход к анализу shopping-агентов. Каждая таблица регулярно обновляется, отражая актуальные тарифы на доставку, изменения комиссий и новые промо-акции. Это экономит часы ручного поиска информации.',
  seo_section_text_3: 'Наш spreadsheet-инструмент особенно полезен для новичков в сфере закупок из Китая. Пошаговые инструкции, встроенные в таблицы, помогут вам разобраться в процессе: от выбора товара на Taobao до получения посылки в вашей стране. Yoybuy Sheet делает международный шоппинг простым и прозрачным.',
  seo_section_text_4: 'Экономия — ключевое преимущество использования Yoybuy Sheet. Сравнивая комиссии агентов, курсы валют и стоимость международной доставки в одной таблице, вы можете сэкономить до 30% от общей стоимости заказа. Для регулярных покупателей эта экономия может составлять сотни долларов в год.',
  guide_title: 'Полное руководство по Yoybuy Sheet',
  guide_description: 'Узнайте, как использовать Yoybuy Sheet для максимальной экономии при покупках из Китая. Пошаговое руководство для начинающих и опытных пользователей.',
  footer_text: 'Yoybuy Sheet — независимый инструмент сравнения shopping-агентов Китая. Мы не affiliated с каким-либо агентом.',
  footer_privacy: 'Конфиденциальность',
  footer_terms: 'Условия использования',
  footer_copyright: '© 2026 Yoybuy.skin. Все права защищены.',
  select_category: 'Выберите категорию...',
};

export default common;